import { Text } from '@ui/themed';

export function PlanAvailabilityBadge({ label, planName }: { label: string; planName: string }) {
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-spark-border-default bg-gray-50 px-3 py-1">
      <Text variant="secondary">{label}</Text>
      <span className="inline-block rounded bg-linear-to-r from-gray-500 to-gray-900 px-1 py-px text-[10px] text-white">
        {planName}
      </span>
    </span>
  );
}
